<template>
  <div v-if="compact" class="is-relative">
    <img
      @load="isReady = true"
      src="@/assets/logo.png"
      alt="title"
      style="height: 2.5rem; max-height: none"
    >
    <span
      v-if="isReady"
      class="brand-label is-small font-family-secondary is-uppercase has-text-weight-bold"
    >
    </span>
  </div>
  <div v-else class="is-relative">
    <h1
      v-if="isReady"
      class="brand-label is-size-6 font-family-secondary has-text-weight-bold is-uppercase"
    >
    </h1>
    <div>
      <img
	@load="isReady = true"
	src="@/assets/logo.png"
	alt="title"
	style="height: 3.5rem; max-height: none"
      >
    </div>
  </div>
</template>

<style>
 .brand-label {
   position: absolute;
   bottom: 0.15rem;
   left: 50%;
   transform: translateX(-50%);
   padding-left: 0.75rem;
   letter-spacing: 0.375rem;
   z-index: -1;
 }

 .brand-label.is-small {
   top: 50%;
   transform: translate(-50%, -50%);
   margin-left: -0.2rem;
   padding-top: 0.75rem;
   font-size: 0.75rem;
 }
</style>

<script>
 export default {
   props: {
     compact: {
       type: Boolean,
       default: false
     }
   },
   data() {
     return {
       isReady: false
     }
   }
 }
</script>
